import calendarResponseDataPlugin from "./plugins/calendarResponseDataPlugin"
export default {
  mixins: [calendarResponseDataPlugin]
}
